<ng-container>
  <c-container [fluid]="true" class="px-0">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1 text-white"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <button
      cHeaderToggler
      toggle="visible"
      routerLink="/profile"
      class="px-md-0 me-md-3 d-none d-sm-block text-white fs-6"
    >
      <svg cIcon name="cilUser" size="lg"></svg>
      <span> {{ username }} </span>
    </button>
  </c-container>
</ng-container>
